import {
  GET_LOADED_PAGE_ERR,
  GET_LOADED_PAGE_REQ,
  GET_LOADED_PAGE_RES,
  GET_PAGES_ERR,
  GET_PAGES_REQ,
  GET_PAGES_RES,
  GET_PURE_PAGES_SSR,
} from '../constants';

const initState = {
  pages: [],
  pages_loaded: false,
  // ##### 24-03-21 Komarov

  purepage: [],
  purepage_loaded: false,

  // ##### 25-04-23 Komarov
  loadedpages: {},
  loadedpages_loaded: {},

  // ##### 25-04-07 Komarov
  // preloadedcitiespages: {},
  // preloadedcitiespages_loaded: {},

  pageType: [],
  pageType_loaded: false,

  frontbody: [],
  frontbody_loaded: false,
  frontbody_errors: [],

  pageRegion: [],
  pageRegion_loaded: false,

  hotelPagesFooter: [],
  hotelPagesFooter_loaded: false,

  galleryPage: [],
  galleryPage_loaded: false,
  errors: [],
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case GET_PAGES_REQ:
      return {
        ...state,
        pages_loaded: false,
      };

    case GET_PAGES_RES:
      return {
        ...state,
        pages_loaded: true,
        pages: action.payload,
      };

    case GET_PAGES_ERR:
      return {
        ...state,
        //    ##### 23-09-01 Komarov
        errors: (state.errors && [...state.errors, action.error]) || [
          action.error,
        ],
      };

    // ##### 25-04-23 Komarov
    case GET_LOADED_PAGE_REQ:
      return {
        ...state,
        loadedpages_loaded: {
          ...state.loadedpages_loaded,
          // ##### Komarov 2025-07-28
          [action.payload.spid]: {
            ...state.loadedpages_loaded[action.payload.spid],
            [action.payload.lang]: true,
          },
        },
      };

    // ##### Komarov 2025-07-28
    case GET_LOADED_PAGE_RES:
      let pageContentObject = {};
      action.payload.data.forEach(content_item => { if (!Array.isArray(content_item) && content_item.content_name !== 'Image') pageContentObject[content_item.content_name] = content_item; });
      const pageImage = action.payload.data.find(content_item => content_item.content_name === 'Image');
      return {
        ...state,
        loadedpages: {
          ...state.loadedpages,
          [action.payload.spid]: (state.loadedpages[action.payload.spid]?.Image || !pageImage) ? {
            ...state.loadedpages[action.payload.spid],
            [action.payload.lang]: action.payload.data,
          } : {
            ...state.loadedpages[action.payload.spid],
            [action.payload.lang]: action.payload.data,
            Image: pageImage,
          },
        },
      };

    case GET_LOADED_PAGE_ERR:
      return {
        ...state,
        errors: (state.errors && [...state.errors, action.error]) || [
          action.error,
        ],
      };

    // ##### 25-04-11 Komarov
    /*case GET_PRELOADED_CITY_PAGE_REQ:
      return {
        ...state,
        preloadedcitiespages_loaded: {
          ...state.preloadedcitiespages_loaded,
          [action.payload]: true,
        },
      };

    case GET_PRELOADED_CITY_PAGE_RES:
      return {
        ...state,
        preloadedcitiespages: {
          ...state.preloadedcitiespages,
          [action.payload.id]: action.payload,
        },
      };

    case GET_PRELOADED_CITY_PAGE_ERR:
      return {
        ...state,
        errors: (state.errors && [...state.errors, action.error]) || [
          action.error,
        ],
      };*/

    // ##### 25-03-18 Komarov
    case GET_PURE_PAGES_SSR:
      return {
        ...state,
        purePagesSsr: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
